import {Layout} from 'antd';
import {useTranslation} from 'react-i18next';
import {version} from '../../../../package.json';
import styles from './footer.module.scss';

// eslint-disable-next-line no-unused-vars
const Footer = (props) => {
  const {t} = useTranslation();
  return (
    <Layout.Footer className={styles.footer} style={{}}>
      <span style={{marginLeft: 'auto'}}/>
      <span>
        &copy;
        {' '}
        {new Date().getFullYear()}
        {' '}
        Autexis IT AG
      </span>
      <span style={{marginLeft: 'auto'}}>
        {t('navigation.version')}
        {': '}
        {version}
      </span>
    </Layout.Footer>
  );
};

export default Footer;
